<ng-container *ngIf="formPrincipal">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">{{ modelRecived ? 'Editar Extraordinario' : 'Agregar Extraordinario' }}</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <button class="btn-new" mat-raised-button color="accent" appPermissionControl="P137B0002" (click)="modelRecived ? update(form.value) : create(form.value)">
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button class="btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P137B0001"><mat-icon>arrow_back</mat-icon>Cancelar</button>
      </div>
    </div>
  </div>

  <form class="mt-5" [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P137F0001">
    <div class="form-row">
      <!-- Variable -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Variable</label>
        <input id="numVar" class="form-control" formControlName="numVar" type="number" [readonly]="modelRecived" required appPermissionControl="P137K0001" />
      </div>

      <!-- Descripcion -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Description</label>
        <input class="form-control" formControlName="descripcion" type="text" required appPermissionControl="P137K0002" />
      </div>

      <div class="line-break"></div>

      <!-- Aplica Pago -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Aplica Pago</label>
        <select class="form-control" formControlName="formula" appPermissionControl="P137K0003">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of aplicaPago" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>

      <!-- Factor -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Factor</label>
        <select class="form-control" formControlName="claveTasa" required appPermissionControl="P137K0004">
          <option value>-- Seleccione --</option>
          <option *ngFor="let tasa of tasas" [value]="tasa.clave">{{ tasa.clave }} | {{ tasa.descripcion }}</option>
        </select>
      </div>

      <!-- Inferior -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Inferior</label>
        <input class="form-control" placeholder="1" formControlName="amortInf" type="number" appPermissionControl="P137K0005" />
      </div>

      <!-- Valor Fijo -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Valor Fijo</label>
        <input class="form-control" placeholder="0.2" formControlName="valorFijo" type="number" appPermissionControl="P137K0006" />
      </div>
    </div>
  </form>
</ng-container>
